<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'commands.parentTitle' | translate }}"></app-page-header>
  </div>

  @if (selectedInstallationsView) {
  <app-painel-fav [options]="selectedInstallations" [selectedOption]="selectedInstallations"></app-painel-fav>
  }

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <!-- Sidebar responsavel por filtrar as instalações -->
        <div class="form-fields-box" [ngClass]="!filterInstallation ? 'closed' : ''">
          <h2 (click)="isFilterInstallation()">
            {{ "commands.title-form-filter" | translate }}
          </h2>
          <hr [ngClass]="!filterInstallation ? 'hr-open' : ''" />

          <form [formGroup]="installationForm">
            <div class="form-step">
              <div class="circle-number">1</div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  "commands.form-reference" | translate
                  }}</mat-label>
                <input matInput formControlName="reference" />
              </mat-form-field>
            </div>

            <div class="form-step">
              <div class="circle-number">2</div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  "commands.form-serial_number" | translate
                  }}</mat-label>
                <input matInput formControlName="serialNumber" />
              </mat-form-field>
            </div>

            <div class="form-step">
              <div class="circle-number">3</div>
              <mat-form-field appearance="outline">
                <mat-label>{{ "commands.form-gateway" | translate }}</mat-label>
                <mat-select formControlName="gateway">
                  @for (gateway of gatewayList; track gateway) {
                  <mat-option [value]="gateway.id">
                    {{gateway.reference}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-step inputFile">
              <div class="circle-number">4</div>
              <input type="file" class="form-control" id="inputGroupFile04" [accept]="'.csv'"
                aria-describedby="inputGroupFileAddon04" aria-label="Upload" #fileUploadSimple
                (change)="getTextFromFile($event)">
              <br>
            </div>

            <div class="form-step">
              @if (installationList.length > 0) {
              <div class="circle-number">
                5
              </div>
              }
              @if (installationList.length > 0) {
              <div class="btn btn-success view-installations" (click)="openModalPage()">
                {{ "commands.installationList" | translate }}
              </div>
              }
            </div>

            <button class="btn btn-primary" type="button" id="inputGroupFileAddon04" (click)="downloadCsvFile()"
              type="submit">
              {{'commands.download-model-import' | translate}}
            </button>

            @if (!isLoadingImportFilter) {
            <button class="btn btn-secondary" type="button" id="inputGroupFileAddon04" (click)="importDataFromCSV()"
              [disabled]="isDisabledImportButton" type="submit">
              {{'commands.import-button' | translate}}
            </button>
            }

            @if (isLoadingImportFilter) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
            @if (!isLoadingInstallationFilter) {
            <button title="Filtrar" (click)="getInstallationsByCompanyId()" [disabled]="checkInstallationFilter()"
              class="btn btn-success mb-2 filter">
              {{ "commands.btn-filter" | translate }}
            </button>
            }

            @if (isLoadingInstallationFilter) {
            <br />
            }
            @if (isLoadingInstallationFilter && filterInstallation) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
          </form>
        </div>

        <!-- Select responsavel pelas consultas -->
        @if (installationList.length > 0) {
        <div class="form-fields-box" [ngClass]="!consultSidebar ? 'closed' : ''">
          <h2 (click)="consultFilter()">
            {{ "commands.consult-filter" | translate }}
          </h2>
          <hr [ngClass]="!consultSidebar ? 'hr-open' : ''" />
          <div class="options-consultation">
            @if (!setUp && !turnOn) {
            <mat-slide-toggle class="mat-slide-toggle-content" (change)="checkConsult('consult')" [color]="color"
              [(ngModel)]="consultIsChecked">{{ "commands.consult" |
              translate }}</mat-slide-toggle>
            }
            @if (consultIsChecked) {
            <section class="consult">
              <mat-radio-group [(ngModel)]="consultValue" [color]="color">
                <mat-radio-button class="mat-radio" value="STATUS">{{
                  "commands.consult-status" | translate
                  }}</mat-radio-button>
                <mat-radio-button class="mat-radio" value="DIAGNOSTIC">{{
                  "commands.consult-diagnostic" | translate
                  }}</mat-radio-button>
                <mat-radio-button class="mat-radio" value="PARAMETERS">{{
                  "commands.consult-parameters" | translate
                  }}</mat-radio-button>
                <mat-radio-button class="mat-radio" value="MEASUREMENT">{{
                  "commands.commands-measurement" | translate
                  }}</mat-radio-button>
                <mat-radio-button class="mat-radio" value="LATEST_MEASUREMENT">{{
                  "commands.consult-last-measurement" | translate
                  }}</mat-radio-button>
                <mat-radio-button class="mat-radio" value="VERSION">{{
                  "commands.consult-version" | translate
                  }}</mat-radio-button>
              </mat-radio-group>
            </section>
            }
            <!-- Sessão Ligar/Desligar -->
            @if (!setUp && !consultIsChecked) {
            <mat-slide-toggle class="mat-slide-toggle-content" (change)="checkConsult('turnOn')" [color]="color"
              [(ngModel)]="turnOn">{{ "commands.turn-on-off" |
              translate }}</mat-slide-toggle>
            }
            @if (turnOn) {
            <section class="turn-on">
              <mat-radio-group [(ngModel)]="turnOnValue" [color]="color">
                <mat-radio-button class="mat-radio" value="on">{{
                  "commands.turn-on" | translate
                  }}</mat-radio-button>
                <mat-radio-button class="mat-radio" value="off">{{
                  "commands.turn-off" | translate
                  }}</mat-radio-button>
              </mat-radio-group>
            </section>
            }
            <!-- Sessão Configurar -->
            @if (!turnOn && !consultIsChecked) {
            <mat-slide-toggle class="mat-slide-toggle-content" (change)="checkConsult('setUp')" [color]="color"
              [(ngModel)]="setUp">{{ "commands.configure" | translate
              }}</mat-slide-toggle>
            }
            <br />
            @if (setUp) {
            <mat-form-field class="parameter" appearance="outline"><br />
              <mat-label>{{
                "commands.configure-parameter" | translate
                }}</mat-label>
              <mat-select [(ngModel)]="settingsForm">
                <!-- <mat-option class="form-control" value="TGE">{{
                        "commands.configure-parameter-tge" | translate
                      }}</mat-option> -->
                <mat-option class="form-control" value="MCA">{{
                  "commands.configure-parameter-mca" | translate
                  }}</mat-option>
                <mat-option class="form-control" value="DIM">{{
                  "commands.configure-parameter-dim" | translate
                  }}</mat-option>
                <mat-option class="form-control" value="PSL">{{
                  "commands.configure-parameter-psl" | translate
                  }}</mat-option>
                <mat-option class="form-control" value="OPM">{{
                  "commands.configure-parameter-opm" | translate
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
            }
            <!-- Div responsável por coletar o valor de intervalo de msn que será enviado por comando
                <div *ngIf="settingsForm === 'TGE' && setUp">
                  <mat-form-field appearance="fill">
                    <mat-label>{{ "commands.min-tge" | translate }}</mat-label>
                    <input matInput type="number" min="0" max="32767" [(ngModel)]="minTGE" />
                  </mat-form-field>
                </div> -->
            <!-- Div responsável por coletar a prioridade de atuação do usuário que será enviada por comando -->
            @if (settingsForm === 'MCA' && setUp) {
            <div>
              <mat-radio-group [color]="color" [(ngModel)]="valueMCA">
                <mat-radio-button [value]="false">{{
                  "commands.command-schedule" | translate
                  }}</mat-radio-button>
                <mat-radio-button [value]="true">{{
                  "commands.command-brightness-sensor" | translate
                  }}</mat-radio-button>
              </mat-radio-group>
            </div>
            }
            <!-- Div responsável por coletar o valor de dimerização que será enviado por comando -->
            @if (settingsForm === 'DIM' && setUp) {
            <div>
              <label class="custom-range-p">
                {{ "commands.value-dim" | translate }} {{ dimmingValue }}%
              </label>
              <input type="range" class="form-range" id="customRange1" [(ngModel)]="dimmingValue" />
            </div>
            }
            <!-- Div responsável por coletar a presença de luminosidade do usuário que será enviada por comando -->
            @if (settingsForm === 'PSL' && setUp) {
            <div>
              <mat-radio-group [color]="color" [(ngModel)]="valuePSL">
                <mat-radio-button [value]="false">{{
                  "commands.not-light-sensor" | translate
                  }}</mat-radio-button>
                <mat-radio-button [value]="true">{{
                  "commands.light-sensor" | translate
                  }}</mat-radio-button>
              </mat-radio-group>
            </div>
            }
            <!-- Div responsável por coletar o modo de operação do usuário que será enviada por comando -->
            @if (settingsForm === 'OPM' && setUp) {
            <div>
              <mat-radio-group [color]="color" [(ngModel)]="valueOPM">
                <mat-radio-button [value]="0">{{
                  "commands.manual-operation-mode" | translate
                  }}</mat-radio-button>
                <mat-radio-button [value]="1">{{
                  "commands.automatic-operation-mode" | translate
                  }}</mat-radio-button>
                <mat-radio-button [value]="2">{{
                  "commands.scheduled-operation-mode" | translate
                  }}</mat-radio-button>
                <mat-radio-button [value]="3">{{
                  "commands.mixed-operation-mode" | translate
                  }}</mat-radio-button>
              </mat-radio-group>
            </div>
            }
          </div>
          @if (!isLoadingInstallationFilter) {
          <button title="Enviar" (click)="consultationForm()" class="btn btn-success mb-2">
            {{ "commands.btn-send" | translate }}
          </button>
          }
          @if (isLoadingInstallationFilter && consultSidebar) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
        }

        <!-- Sessão de filtro da tabela -->
        <div class="form-fields-box" [ngClass]="!isFilterTable ? 'closed' : ''">
          <h2 (click)="filterTable()">
            {{ "commands.filter-commands" | translate }}
          </h2>
          <hr [ngClass]="!isFilterTable ? 'hr-open' : ''" />

          <mat-form-field class="parameter" appearance="outline">
            <mat-label>{{ "commands.filter-parameter" | translate }}</mat-label>
            <mat-select [(ngModel)]="tableFilterForm">
              <mat-option class="form-control" [value]="null">{{
                "commands.filter-parameter-none" | translate
                }}</mat-option>
              <mat-option class="form-control" value="SWITCH_ON">{{
                "commands.filter-parameter-turn-on" | translate
                }}</mat-option>
              <mat-option class="form-control" value="SWITCH_OFF">{{
                "commands.filter-parameter-turn-off" | translate
                }}</mat-option>
              <mat-option class="form-control" value="QUERY">{{
                "commands.filter-parameter-consult" | translate
                }}</mat-option>
              <mat-option class="form-control" value="SET_PARAMETER">{{
                "commands.filter-parameter-configure" | translate
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          @if (!isLoadingInstallationFilter) {
          <button title="Filtrar" (click)="filterCommands(null)" class="btn btn-success mb-2">
            {{ "commands.filter-parameter-btn-filter" | translate }}
          </button>
          }
          @if (isLoadingInstallationFilter && isFilterTable) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <!-- Sessão tabela -->
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="downloadCSV()" (downloadPDF)="downloadPDF()">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [rows]="pageSize" [totalRecords]="length" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="demo-date" style="width: 12rem">{{ "commands.table-requested-date" | translate }}
              </th>
              <th pSortableColumn="demo-type" style="width: 12rem">{{ "commands.table-type" | translate }}</th>
              <th pSortableColumn="demo-sendBy" style="width: 12rem">{{ "commands.table-sent-by" | translate }}</th>
              <th pSortableColumn="demo-answer" style="width: 12rem">{{ "commands.table-response" | translate }}</th>
              <th pSortableColumn="demo-view" style="width: 12rem">Visualizar</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.requestDt}}</td>
              <td>{{row.type}}</td>
              <td>{{row.user.firstName }} {{
                row.user.lastName}}</td>
              <td>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" attr.style="width: {{
                    (row.equipmentsQueued / row.equipments.length) * 100
                  }}%;" attr.aria-valuenow="{{ row.equipmentsQueued }}" aria-valuemin="0"
                    attr.aria-valuemax="{{ row.equipments.length }}"></div>
                </div>
                {{ row.equipmentsQueued }} /
                {{ row.equipments.length }}
              </td>
              <td>
                <p-button styleClass="btn-actions" icon="pi pi-eye" class="mr-2" [rounded]="true"
                  title="Visualizar comando" (click)="sendCommandsToModal(row.equipments, row)" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
</div>